/**
 * Enumeration of the video types
 */
export enum VideoType {

    /**
     * The camera video type.
     */
    CAMERA = 'camera',

    /**
     * The desktop video type.
     */
    DESKTOP = 'desktop',

    /**
     * The high fps desktop video type.
     */
    DESKTOP_HIGH_FPS = 'desktop_high_fps'
}
